module.exports = __webpack_public_path__ + "static/media/YM22_1.c87d8a9d.jpg";